"use client";
import AppImage from '@/components/ui/AppImage';

export default function HeroSection() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <header className="min-h-screen flex items-center px-6 py-20 bg-gradient-to-br from-slate-50 to-white" dir="rtl">
      <div className="max-w-7xl mx-auto w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          
          {/* Text Content Section */}
          <div className="order-1 lg:order-2 fade-in-up">
            {/* Main Heading */}
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight text-slate-900 mb-4 leading-tight font-cairo mt-12">
              <span className="font-extrabold text-5xl md:text-7xl lg:text-8xl">الأنيق المتميز</span>{' '}
              <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-slate-700 via-slate-600 to-slate-500">
                لاستيراد وسائل النقل وملحقاته
              </span>
            </h1>
            
            {/* English Company Name */}
            <p className="text-xl md:text-2xl lg:text-3xl font-semibold text-slate-600 mb-8 font-inter">
              Al-Aneeq Almutamayyiz Company for Importing Vehicles & Accessories
            </p>

            {/* Description */}
            <p className="text-lg text-slate-700 font-light leading-relaxed border-r border-slate-300 pr-6 mb-10 font-cairo">
              شركة ليبية متخصصة في استيراد وسائل النقل وملحقاتها من مصادر موثوقة،
              نعمل وفق معايير مهنية عالية لتلبية احتياجات السوق المحلي بكفاءة وجودة.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row items-start gap-4">
              <button
                onClick={() => scrollToSection('about')}
                className="px-8 py-4 bg-primary text-white font-medium rounded-lg hover:bg-primary/90 transition-all flex items-center gap-3 group text-sm tracking-wide font-cairo shadow-lg">
                
                اكتشف المزيد
                <svg
                  className="w-4 h-4 group-hover:-translate-x-1 transition-transform"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor">
                  
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
              </button>

              <button
                onClick={() => scrollToSection('contact')}
                className="px-8 py-4 border border-slate-300 bg-white text-slate-800 hover:bg-slate-50 font-medium rounded-lg transition-colors text-sm tracking-wide font-cairo shadow-md">
                
                تواصل معنا
              </button>
            </div>
          </div>

          {/* Image Section */}
          <div className="order-2 lg:order-1 fade-in-up">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <AppImage
                src="/assets/images/ChatGPT_Image_Feb_7__2026_at_07_49_51_PM-1770502453147.png"
                alt="شاحنات نقل حديثة في ساحة شحن مع حاويات ملونة تحت سماء زرقاء"
                className="w-full h-[500px] lg:h-[600px] object-cover"
              />
              {/* Subtle border overlay */}
              <div className="absolute inset-0 ring-1 ring-inset ring-slate-900/10 rounded-2xl"></div>
            </div>
          </div>

        </div>
      </div>
    </header>
  );
}